import { FC, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RootState } from 'src/Store'

import { GeoModel } from 'src/dataSources/geo/GeoModel'
import { ToolType } from 'src/Enums'
import { virtualBoreholeInfoActions } from 'src/actions/VirtualBoreholeInfoActions'
import { virtualBoreholeInfoStateInitial } from 'src/reducers/VirtualBoreholeInfoReducer'

import ToolBarSlider from '../toolbarslider/ToolBarSlider'

import { virtualBoreholeSettingsStyle } from './VirtualBoreholeSettings.style'
import { Tooltip } from '@material-ui/core'
import { tooltipDelay } from 'src/Constants'
import { LeftSideBarIcon, LeftSideBarIconType } from 'src/components/leftsidebar/leftsidebaricon/LeftSideBarIcon'
import { useIntl } from 'react-intl'
import { LayerParams } from 'src/dataSources/layers/LayerRegistry'

export interface VirtualBoreholeSettingsProps { } // eslint-disable-line @typescript-eslint/no-empty-interface

const defaultProps: VirtualBoreholeSettingsProps = {}

export const VirtualBoreholeSettings: FC<VirtualBoreholeSettingsProps> = (props: VirtualBoreholeSettingsProps) => {
  const dispatch = useDispatch()
  const classes = virtualBoreholeSettingsStyle()
  const intl = useIntl()

  const layerParams = useSelector((state: RootState): LayerParams[] => state.mapState.layerParams)
  const selectedGeoModel = useSelector((state: RootState): GeoModel | undefined => state.generalState.selectedGeoModel)
  const selectedTool = useSelector((state: RootState): ToolType => state.generalState.selectedTool)
  const virtualBoreholeMaxDepth = useSelector((state: RootState): number => state.virtualBoreholeInfoState.maxDepth)
  const virtualBoreholeCoords = useSelector((state: RootState): number[] => state.virtualBoreholeInfoState.coordinates)

  const [updatingVirtualBorehole, setUpdatingVirtualBorehole] = useState<number | undefined>(undefined)

  useEffect(() => {
    if (selectedTool === ToolType.VIRTUAL_BOREHOLE) {
      dispatch(virtualBoreholeInfoActions.updateVirtualBorehole(virtualBoreholeCoords))
    }
    // eslint-disable-next-line
  }, [selectedGeoModel, layerParams])

  const startUpdateVirtualBoreholeInterval = (): void => {
    const timeout = window.setTimeout(() => {
      dispatch(virtualBoreholeInfoActions.updateVirtualBorehole(virtualBoreholeCoords))
      setUpdatingVirtualBorehole(undefined)
    }, 500)
    setUpdatingVirtualBorehole(timeout)
  }

  const setMaxDepth = (maxDepth: number, refreshVirtualBorehole: boolean): void => {
    dispatch(virtualBoreholeInfoActions.setMaxDepth(maxDepth))
    if (refreshVirtualBorehole && virtualBoreholeCoords !== virtualBoreholeInfoStateInitial.coordinates) {
      if (updatingVirtualBorehole === undefined) {
        startUpdateVirtualBoreholeInterval()
      } else {
        clearTimeout(updatingVirtualBorehole)
        startUpdateVirtualBoreholeInterval()
      }
    }
  }

  return (
    <div className={classes.root}>
      <Tooltip
        title={intl.formatMessage({ id: 'tools.virtualborehole' })}
        enterDelay={tooltipDelay}
        placement='bottom'
      >
        <div className={classes.toolIcon}>
          <LeftSideBarIcon icon={LeftSideBarIconType.VirtualBorehole} selected disabled={false} />
        </div>
      </Tooltip>
      <div className={classes.setting}>
        <ToolBarSlider label='tools.virtualborehole.maxDepth' name='maxdepth' min={-200} max={200} step={10} unit='m' value={virtualBoreholeMaxDepth} onChangeHandler={setMaxDepth} />
      </div>
    </div>
  )
}

VirtualBoreholeSettings.defaultProps = defaultProps

export default VirtualBoreholeSettings
